import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let AttentionComp;

class Attention extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: AttentionComp };
      }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/attention-comp" */
            "../../../components/javascript/zcat-components/attention-comp"
        ).then(function(res) {
            AttentionComp = res.AttentionComp;
        }));

        
;
    }
}

export {Attention};

